import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@mui/material';

import { useStyles } from './styles';
import { useMytaverse } from '@providers/MytaverseProvider';
import { usePolicyState } from '@core/myta/components/PolicyModal/context';

const LegalNotes = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { appSettings } = useMytaverse();
  const { setOpen, setViewOnly } = usePolicyState();

  // When the world has actual terms configured, the legal links open the same
  // dialog shown on first login (read-only). Since that dialog is a single
  // combined document, both labels collapse into one link. Otherwise fall back
  // to the legacy external URLs, which are genuinely two separate addresses.
  const hasInAppTerms =
    Boolean(appSettings?.termsAndConditions?.content?.trim()) ||
    Boolean(appSettings?.termsPDFUrl);

  const openTerms = () => {
    setViewOnly(true);
    setOpen(true);
  };

  if (hasInAppTerms) {
    return (
      <Typography sx={classes.text}>
        {translate('legalNotes.preFix')}{' '}
        <Link
          component="button"
          onClick={openTerms}
          sx={classes.link}
          data-testid="legal-notes-link"
        >
          {translate('legalNotes.terms')} {translate('legalNotes.and')}{' '}
          {translate('legalNotes.privacy')}
        </Link>
      </Typography>
    );
  }

  return (
    <Typography sx={classes.text}>
      {translate('legalNotes.preFix')}{' '}
      <Link
        href={appSettings?.termsOfServiceUrl}
        target="_blank"
        sx={classes.link}
        data-testid="legal-notes-link"
      >
        {translate('legalNotes.terms')}
      </Link>{' '}
      {translate('legalNotes.and')}{' '}
      <Link
        href={appSettings?.privacyPolicyUrl}
        target="_blank"
        sx={classes.link}
      >
        {translate('legalNotes.privacy')}
      </Link>
    </Typography>
  );
};

export default LegalNotes;
